import axios from '@/utils/axios'

export const getPayment = (payload) => {
    return axios.get('/payment', {
        params: payload
    })
}

export const createPayment = (data) => {
    return axios.post('/payment', data)
}

export const updatePayment = (id, data) => {
    return axios.put(`/payment/${id}`, data)
}

export const getPaymentById = (id) => {
    return axios.get(`/payment/${id}`)
}

export const deletePayment = (id) => {
    return axios.delete(`/payment/${id}`)
}